import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";
import anushkaPhoto from "../../Assets/Profile pics/Anushkasarkar.jpeg";
import rudraPhoto from "../../Assets/Profile pics/Rudra sir.jpeg";
import rounakPhoto from "../../Assets/Profile pics/rounakbarman.jpeg";
import ranjanPhoto from "../../Assets/Profile pics/RanjanBanerjee2.0.jpeg";
import SubhankarPhoto from "../../Assets/Profile pics/Subhankarsir2.0.jpeg";
import sayanPhoto from "../../Assets/Profile pics/Sayandas2.0.jpeg";
import dipankarPhoto from "../../Assets/Profile pics/Dipankarbasu.jpeg";
import debidashPhoto from "../../Assets/Profile pics/Debidas Ghosh.jpg.jpeg";
import abirPhoto from "../../Assets/Profile pics/Abir2.0.jpeg";
import soumyaPhoto from "../../Assets/Profile pics/soumya2.0.jpeg";
import abhiPhoto from "../../Assets/Profile pics/Abhi2.0.jpeg";
import MithunPhoto from "../../Assets/Profile pics/Mithun2.0.jpeg";
import KoushikPhoto from "../../Assets/Profile pics/Koushikpaul.jpeg";
import AnupPhoto from "../../Assets/Profile pics/Anup2.0.jpeg";
import MoumitaPhoto from "../../Assets/Profile pics/Moumita.jpeg";
import RounakkarmakarPhoto from "../../Assets/Profile pics/Rounakkarmakar.jpeg";
 
import "./StaffSection.css";
 
// Add confirmed profile details and personal social URLs when available.
const staffMembers = [
  {
    id: "anushka", name: "Anushka Sarkar", category: "Teaching", role: "Assistant Professor Department of English", photo: anushkaPhoto,
    qualification: "MA in English", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "rudra", name: "Rudranil Banerjee", category: "Teaching", role: "Industrial App and Fullstack Developer", photo: rudraPhoto,
    qualification: "B Tech in Electronics and Communication Engineering", passion: "To be updated",
    about: "Full-stack developer building modern web solutions with React, Node.js, MongoDB, and DSA.",
    socials: {},
  },
  {
    id: "rounak", name: "Rounak Barman", category: "Teaching", role: "Industrial Full Stack Developer", photo: rounakPhoto,
    qualification: "B Tech in Electronics and Communication Engineering", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "ranjan", name: "Ranjan Banerjee", category: "Teaching", role: "Assistant Professor Department of Computer Science", photo: ranjanPhoto,
    qualification: "Diploma, BTech, MTech, MBA, PHD Pursuing", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "Subhankar", name: "Subhankar Paul", category: "Teaching", role: "Industrial Tax Consultant Trainer", photo: SubhankarPhoto,
    qualification: "Graduation and Tax Consultant", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "karmakar", name: "Rounak Karmakar", category: "Teaching", role: "", photo: RounakkarmakarPhoto,
    qualification: "", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "sayan", name: "Sayan Das", category: "Teaching", role: "Academic assistant professor and exam controller & junior web developer", photo: sayanPhoto,
    qualification: "BCA Pursuing", passion: "To be updated",
    about: "Full-stack developer focused on building scalable, modern, and user-friendly web applications with cutting-edge technologies.",
    socials: {},
  },
  {
    id: "dipankar", name: "Dipankar Basu", category: "Teaching", role: "Academic Assistant Professor", photo: dipankarPhoto,
    qualification: "Diploma, BTech, MTech, PHD Pursuing", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "debidash", name: "Debi Das Ghosh", category: "Teaching", role: "Senior Motion Graphics Animator", photo: debidashPhoto,
    qualification: "BA Graduate", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "Mithun", name: "Mithun Chakraborty", category: "Teaching", role: "Assistant Professor Department of Finance", photo: MithunPhoto,
    qualification: "M Com", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "Anup", name: "Anup Kr Yadav", category: "Teaching", role: "Assistant Professor Department Of English", photo: AnupPhoto,
    qualification: "MA In English", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "Koushik", name: "Koushik Das", category: "Teaching", role: "Assistant Professor Department Of Computer Science", photo: KoushikPhoto,
    qualification: "BSC Mathematics, MSC Mathematics, M Tech CSC, PHD Pursuing", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "abir", name: "Abir Chakraborty", category: "Non-teaching", role: "Senior floor manager,Jr finance observer.,CRM controller. ,Assistant Academic councillor", photo: abirPhoto,
    qualification: "BCOM(DFA)", passion: "To be updated",
    about: "Always Focus on my Service quality and Time punctuality, Do your best Forget the rest",
    socials: {},
  },
  {
    id: "soumya", name: "Soumyajit Paul", category: "Non-teaching", role: "Marketing executive ,Junior academy councillor ,Junior Graphic designer", photo: soumyaPhoto,
    qualification: "BCA Pursuing", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "abhi", name: "Abhimanyu Shil", category: "Non-teaching", role: "Junior academy counsellor ,Assistant floor controller,Student enquiry controller,Junior video editor", photo: abhiPhoto,
    qualification: "BCA Pursuing", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
  {
    id: "moumita", name: "Moumita Roy", category: "Non-teaching", role: "Academic councillor & Assistant Hospitality control & academic caller", photo: MoumitaPhoto,
    qualification: "English Hons Pursuing", passion: "To be updated",
    about: "Profile details will be updated soon.",
    socials: {},
  },
];
 
const socialPlatforms = [
  { key: "instagram", label: "Instagram", Icon: FaInstagram },
  { key: "facebook", label: "Facebook", Icon: FaFacebookF },
  { key: "youtube", label: "YouTube", Icon: FaYoutube },
];
 
// Cards in these categories open the popup.
const CLICKABLE_CATEGORIES = ["Teaching", "Non-teaching"];
 
/* ---------- Popup (rendered in document.body so slider transforms can't affect it) ---------- */
function StaffModal({ member, onClose }) {
  const closeBtnRef = useRef(null);
  const dialogRef = useRef(null);
 
  useEffect(() => {
    const previouslyFocused = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden"; // lock page scroll
    closeBtnRef.current?.focus();
 
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
        return;
      }
      // Keep keyboard focus inside the dialog
      if (e.key === "Tab" && dialogRef.current) {
        const focusable = dialogRef.current.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
 
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
      previouslyFocused?.focus?.();
    };
  }, [onClose]);
 
  const activeSocials = socialPlatforms.filter(({ key }) => member.socials[key]);
 
  return createPortal(
    <div className="staff-modal__overlay" onClick={onClose}>
      <div
        className="staff-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="staff-modal-title"
        ref={dialogRef}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="staff-modal__close"
          onClick={onClose}
          aria-label="Close staff details"
          ref={closeBtnRef}
        >
          &times;
        </button>
 
        <div className="staff-modal__photo">
          <img src={member.photo} alt={member.name} />
        </div>
 
        <div className="staff-modal__body">
          <h3 id="staff-modal-title">{member.name}</h3>
          <p className="staff-modal__role">{member.role}</p>
 
          <dl className="staff-modal__details">
            <div><dt>Qualification</dt><dd>{member.qualification}</dd></div>
            <div><dt>Passion</dt><dd>{member.passion}</dd></div>
            <div><dt>About</dt><dd>{member.about}</dd></div>
          </dl>
 
          {activeSocials.length > 0 && (
            <div className="staff-modal__socials">
              {activeSocials.map(({ key, label, Icon }) => (
                <a
                  key={key}
                  href={member.socials[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${member.name} on ${label} (opens in a new tab)`}
                  title={label}
                >
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
 
/* ---------- Main section ---------- */
export default function StaffSection() {
  const [selectedMember, setSelectedMember] = useState(null);
  const closeModal = useCallback(() => setSelectedMember(null), []);
 
  return (
    <section className="home-staff" aria-labelledby="home-staff-title">
      <div className="home-staff__container">
        <header className="home-staff__heading">
          <span className="home-staff__eyebrow">People behind the journey</span>
          <h2 id="home-staff-title">Meet our team</h2>
          <p>Teaching and non-teaching staff, united by a passion for learning.</p>
        </header>
 
        {["Teaching", "Non-teaching"].map((category) => {
          const isClickable = CLICKABLE_CATEGORIES.includes(category);
 
          return (
            <div className="home-staff__group" key={category}>
              <h3>{category} staff</h3>
              <div
                className={`home-staff__slider${category === "Non-teaching" ? " home-staff__slider--reverse" : ""}`}
                role="region"
                aria-label={`${category} staff slider`}
              >
                <div className="home-staff__track">
                  {[0, 1].map((copy) => (
                    <div
                      className="home-staff__slide-group"
                      key={copy}
                      aria-hidden={copy === 1 ? true : undefined}
                    >
                      {staffMembers
                        .filter((member) => member.category === category)
                        .map((member) => {
                          const clickProps = isClickable
                            ? {
                                role: "button",
                                tabIndex: copy === 1 ? -1 : 0,
                                "aria-haspopup": "dialog",
                                "aria-label": `View full details of ${member.name}`,
                                onClick: () => setSelectedMember(member),
                                onKeyDown: (e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    setSelectedMember(member);
                                  }
                                },
                              }
                            : {};
 
                          return (
                            <article
                              className={`home-staff__card${isClickable ? " home-staff__card--clickable" : ""}`}
                              key={member.id}
                              {...clickProps}
                            >
                              <div className="home-staff__identity">
                                <img
                                  src={member.photo}
                                  alt={member.name}
                                  loading="lazy"
                                  width="56"
                                  height="56"
                                />
                                <div>
                                  <h4>{member.name}</h4>
                                  <p>{member.role}</p>
                                </div>
                              </div>
                              <dl className="home-staff__details">
                                <div><dt>Qualification</dt><dd>{member.qualification}</dd></div>
                                <div><dt>Passion</dt><dd>{member.passion}</dd></div>
                                <div><dt>About</dt><dd>{member.about}</dd></div>
                              </dl>
                              <div className="home-staff__socials">
                                {socialPlatforms.map(
                                  ({ key, label, Icon }) =>
                                    member.socials[key] && (
                                      <a
                                        key={key}
                                        href={member.socials[key]}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={`${member.name} on ${label} (opens in a new tab)`}
                                        title={label}
                                        tabIndex={copy === 1 ? -1 : undefined}
                                        onClick={(e) => e.stopPropagation()} // don't open popup when clicking a social link
                                      >
                                        <Icon aria-hidden="true" />
                                      </a>
                                    )
                                )}
                              </div>
                            </article>
                          );
                        })}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
 
      {selectedMember && <StaffModal member={selectedMember} onClose={closeModal} />}
    </section>
  );
}